import { Role } from '@ywwwtseng/ywjs';
export { ad_providers } from '@/lib/ad/constants';

export const networks = [
  'bsc',
  'solana',
  'ethereum',
  'ton',
  'tron',
  'bitcoin',
] as const;
export const roles = [
  Role.ROOT,
  Role.ADMIN,
  Role.WALLET,
  Role.OPERATOR,
  Role.VIEWER,
  Role.USER_TG,
  Role.USER_WEB,
  Role.USER_TEST,
] as const;

export const withdraw_intent_status = ['pending', 'approved', 'broadcasted', 'confirmed', 'failed', 'refunded', 'suspended'] as const;
export const confirmed_transaction_status = ['success', 'paused', 'refunded', 'invalid', 'system', 'skip'] as const;
export const transaction_status = ['pending', 'failed', ...confirmed_transaction_status] as const;
export const right_assignment_status = ['pending', 'verified', 'cancelled'] as const;
export const gift_types = [
  'normal',
  'lucky',
  'exclusive',
  'task',
  'unlimited',
  'activity',
  'share',
  'chat_growth',
] as const;
export const amount_types = ['fixed', 'random'] as const;
export const gift_status = [
  'active',
  'expired',
  'completed',
  'cancelled',
] as const;
export const token_status = ['inactive', 'active', 'rejected'] as const;
export const ad_sources = ['adsgram'] as const;
export const ad_activity_status = ['pending', 'claimed', 'expired'] as const;